import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

// `/login` is the address people guess; sign-in lives at /portal/login.
// Keeps the query and hash, which LoginPage reads (?ref=, ?next=, ...).
export default function LoginRedirect() {
  const { search, hash } = useLocation();
  return <Navigate to={`/portal/login${search}${hash}`} replace />;
}
